(function () {
  'use strict';

  var buttonSelector = '.add-to-cart-adapter[data-variant-id], form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] input[type="submit"]';
  var messages = {
    checking: 'Checking availability…',
    outOfStock: 'This item is currently out of stock and could not be added to your cart.',
    unavailable: 'We could not confirm availability. Please view the accessory product page or try again.',
    buttonLabel: 'Out of stock'
  };
  var shopRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
  var availabilityCache = {};

  function getVariantId(button) {
    var form;
    var idInput;

    if (button.getAttribute('data-variant-id')) {
      return button.getAttribute('data-variant-id');
    }

    form = button.closest('form');
    idInput = form ? form.querySelector('[name="id"]') : null;
    return idInput ? idInput.value : '';
  }

  function getMessageElement(button) {
    var form = button.closest('form');
    var anchor = form || button;
    var message = anchor.nextElementSibling;

    if (!message || !message.classList.contains('dfm-accessory-stock-message')) {
      message = document.createElement('div');
      message.className = 'dfm-accessory-stock-message';
      message.setAttribute('role', 'alert');
      message.setAttribute('aria-live', 'assertive');
      message.hidden = true;
      anchor.insertAdjacentElement('afterend', message);
    }

    return message;
  }

  function showMessage(button, text) {
    var message = getMessageElement(button);
    message.textContent = text;
    message.hidden = false;
  }

  function clearMessage(button) {
    var message = getMessageElement(button);
    message.textContent = '';
    message.hidden = true;
  }

  function rememberLabel(button) {
    if (!button.getAttribute('data-dfm-original-label')) {
      button.setAttribute('data-dfm-original-label', button.tagName === 'INPUT' ? button.value : button.textContent.trim());
    }
  }

  function setButtonLabel(button, label) {
    if (button.tagName === 'INPUT') {
      button.value = label;
    } else {
      button.textContent = label;
    }
  }

  function setUnavailable(button) {
    rememberLabel(button);
    setButtonLabel(button, messages.buttonLabel);
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('dfm-accessory-stock-unavailable');
    showMessage(button, messages.outOfStock);
  }

  function setChecking(button, checking) {
    rememberLabel(button);
    button.disabled = checking;
    button.setAttribute('aria-busy', String(checking));

    if (checking) {
      setButtonLabel(button, messages.checking);
    } else {
      setButtonLabel(button, button.getAttribute('data-dfm-original-label'));
    }
  }

  function getAvailability(variantId, refresh) {
    if (!refresh && Object.prototype.hasOwnProperty.call(availabilityCache, variantId)) {
      return Promise.resolve(availabilityCache[variantId]);
    }

    return fetch(shopRoot + 'variants/' + encodeURIComponent(variantId) + '.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Variant lookup failed: ' + response.status);
      }

      return response.json();
    }).then(function (variant) {
      var available = variant.available === true;
      availabilityCache[variantId] = available;
      return available;
    });
  }

  function isAccessoryButton(button) {
    var form = button.closest('form');

    if (button.closest('[data-product-form], .product_form')) {
      return false;
    }

    if (button.matches('.add-to-cart-adapter[data-variant-id]')) {
      return true;
    }

    return Boolean(
      form &&
      form.matches('[action*="/cart/add"]') &&
      form.querySelector('[name="id"]')
    );
  }

  function checkButtonOnLoad(button) {
    var variantId;

    if (!isAccessoryButton(button)) return;
    variantId = getVariantId(button);
    if (!variantId) return;

    getAvailability(variantId, false).then(function (available) {
      if (!available) setUnavailable(button);
    }).catch(function (error) {
      console.warn('Accessory availability check failed.', error);
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest(buttonSelector);
    var variantId;

    if (!button || !isAccessoryButton(button)) return;

    if (button.getAttribute('data-dfm-stock-bypass') === 'true') {
      button.removeAttribute('data-dfm-stock-bypass');
      return;
    }

    variantId = getVariantId(button);
    if (!variantId) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    clearMessage(button);
    setChecking(button, true);

    getAvailability(variantId, true).then(function (available) {
      if (!available) {
        setChecking(button, false);
        setUnavailable(button);
        return;
      }

      setChecking(button, false);
      button.setAttribute('data-dfm-stock-bypass', 'true');
      button.click();
    }).catch(function (error) {
      setChecking(button, false);
      showMessage(button, messages.unavailable);
      console.warn('Accessory availability check failed.', error);
    });
  }, true);

  function initialize() {
    var buttons = document.querySelectorAll(buttonSelector);
    Array.prototype.forEach.call(buttons, checkButtonOnLoad);
  }

  function observeNewButtons() {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          var buttons;

          if (node.nodeType !== 1) return;

          if (node.matches && node.matches(buttonSelector)) {
            checkButtonOnLoad(node);
          }

          buttons = node.querySelectorAll ? node.querySelectorAll(buttonSelector) : [];
          Array.prototype.forEach.call(buttons, checkButtonOnLoad);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialize();
      observeNewButtons();
    }, { once: true });
  } else {
    initialize();
    observeNewButtons();
  }
}());
